import { useState, useEffect } from 'react';
/**
 * 반응형 사이즈 계산 hook
 * 화면 크기에 따라 적절한 컴포넌트 사이즈를 반환합니다.
 */ export const useResponsiveSize = (baseSize)=>{
    const [effectiveSize, setEffectiveSize] = useState(baseSize);
    useEffect(()=>{
        const handleResize = ()=>{
            let newSize = baseSize;
            if (window.innerWidth <= 350) {
                newSize = baseSize === 'lg' ? 'md' : baseSize === 'md' ? 'sm' : 'xs';
            } else if (window.innerWidth <= 400) {
                newSize = baseSize;
            } else {
                newSize = baseSize;
            }
            setEffectiveSize(newSize);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, [
        baseSize
    ]);
    return effectiveSize;
};
/**
 * 사이즈를 픽셀로 변환
 */ export const sizeToPixels = (size)=>{
    switch(size){
        case 'xs':
            return 24;
        case 'sm':
            return 32;
        case 'md':
            return 40;
        case 'lg':
            return 48;
        default:
            return 40;
    }
};
